import { render, staticRenderFns } from "./ResultExportTable.vue?vue&type=template&id=b97d883c"
import script from "./ResultExportTable.vue?vue&type=script&lang=js"
export * from "./ResultExportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports